import { Capacitor } from '@capacitor/core'
import { useGate, useStore } from 'effector-react'
import { Button } from '~/shared/ui/Buttons'
import {
  Gate,
  $isCardLoading,
  $isQrLoading,
  payWithCardClicked,
  payWithQrClicked,
} from './mode'

type NewTinkoffPayProps = {
  amount: number
  supportsQr?: boolean
}

function openTargetWindow(): Window | null {
  if (Capacitor.isNativePlatform()) return null
  const win = window.open('', '_blank')
  if (win) {
    win.document.write(`
      <html>
        <head><meta charset="utf-8"><title>Оплата</title></head>
        <body style="margin:0;height:100vh;display:flex;align-items:center;justify-content:center;background:#e8f4fd;font-family:sans-serif">
          <p style="font-size:20px;color:#2b6cb0;margin:0">Ожидайте...</p>
        </body>
      </html>
    `)
  }
  return win
}

export function NewTinkoffPay({ amount, supportsQr }: NewTinkoffPayProps) {
  useGate(Gate, { amount })

  const isCardLoading = useStore($isCardLoading)
  const isQrLoading = useStore($isQrLoading)
  const isAnyLoading = isCardLoading || isQrLoading

  return (
    <>
      <Button
        fullWidth
        loading={isCardLoading}
        disabled={isAnyLoading}
        variant='limeFlooded'
        size='large'
        onClick={() => payWithCardClicked(openTargetWindow())}
      >
        {supportsQr ? 'Оплатить картой' : 'Подтвердить'}
      </Button>

      {supportsQr && (
        <Button
          fullWidth
          loading={isQrLoading}
          disabled={isAnyLoading}
          variant='limeFlooded'
          size='large'
          onClick={() => payWithQrClicked(openTargetWindow())}
          style={{ marginTop: '12px' }}
        >
          Оплатить СБП
        </Button>
      )}
    </>
  )
}
